export default {"src":"/org/_next/static/media/key.7a885c9d.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};